import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import PackagingItemUsageView from 'src/sections/packaging-item/view/packaging-item-usage-view';

// Admin-only, same as Stock Count — no seeded READ_* permission gates
// this, deliberately (see WORKFLOW_GUIDE.md).
export default function PackagingItemUsagePage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Packaging Item Usage</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <PackagingItemUsageView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
